import { FC, ReactNode, useEffect, useState } from 'react';
import useDebounce from '@hooks/useDebounce/useDebounce';
import styles from './InputFieldWithDebounce.module.scss';

interface IInputFieldProps {
  placeholder: string;
  name: string;
  className?: string;
  image?: ReactNode;
  debounceAction?: (text: string) => void;
}

/**
 * @param props - The props for the component.
 * @param name - name for the input.
 * @param placeholder - placeholder for the input.
 * @param className - custom class name for the input container.
 * @param image - An image or icon in input.
 * @param debounceAction - Function to use debounce for any action
 * @description - Form input shared component for forms
 * @returns A React component that displays an input.
 */

const InputFieldWithDebounce: FC<IInputFieldProps> = (props) => {
  const { className, image, debounceAction, ...rest } = props;

  const [value, setValue] = useState('');
  const debouncedValue = useDebounce(value);

  useEffect(() => {
    if (debounceAction) {
      debounceAction(debouncedValue);
    }
  }, [debouncedValue]);
  return (
    <div className={styles.inputWrapper}>
      {image || <img src="/icons/search.svg" alt="search-bar" />}
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type="text"
        className={[className].join(' ')}
        {...rest}
      />
    </div>
  );
};

export default InputFieldWithDebounce;
